<template>
  <Toast/>
  <div v-if="loading" class="col-12 spinner-box" style="text-align: center;">
    <ProgressSpinner  style="width:25em;height:25em;z-index: 9999" strokeWidth="2" fill="none"
                     animationDuration=".5s"/>
  </div>
  <router-view/>
</template>

<script>
import EventBus from "@/AppEventBus";
import {useApplicationStore} from "@/store/applicationStore";
import {VueScreenSizeMixin} from "vue-screen-size";
import {useLoadingStore} from "@/store/loadingStore";

export default {
  mixins: [VueScreenSizeMixin],
  emits: ['change-theme'],
  beforeCreate() {
    this.applicationStore = useApplicationStore()
    this.loadingStore = useLoadingStore()
  },
  beforeUpdate() {
    if (this.mobileMenuActive)
      this.addClass(document.body, 'body-overflow-hidden');
    else
      this.removeClass(document.body, 'body-overflow-hidden');
  },
  created() {
    window.addEventListener('scroll', () => {
      this.scrollPositionY = window.scrollY.toFixed(0);
    })
  },
  data() {
    return {
      scrollPositionY: 0,
      layoutMode: 'overlay',
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,
      menu: []
    }
  },
  computed: {
    user() {
      return this.userStore.user
    },
    loading() {
      return this.loadingStore.loading
    },
    containerClass() {
      return ['layout-wrapper', {
        'layout-overlay': this.layoutMode === 'overlay',
        'layout-static': this.layoutMode === 'static',
        'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
        'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
        'layout-mobile-sidebar-active': this.mobileMenuActive,
        'p-input-filled': this.$primevue.config.inputStyle === 'filled',
        'p-ripple-disabled': this.$primevue.config.ripple === false
      }];
    },
    logo() {
      return (this.$appState.darkTheme) ? "images/logo-white.svg" : "images/logo.svg";
    }
  },
  watch: {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups();
    }
  },
  methods: {
    dynamicMenuHeight() {
      const top = 133
      return this.scrollPositionY <= 133 ? ('top:' + (top - this.scrollPositionY)) + 'px' : 'top: ' + 0
    },
    goBack() {
      location.href = this.applicationStore.callBackUrl
    },
    toHome() {
      EventBus.emit('navigation-home');
    },
    toPressMediaHub() {
      location.href = "https://www.esmo.org/newsroom/esmo-press-office"
    },
    toEventsCalendar() {
      location.href = "https://www.esmo.org/newsroom/esmo-press-office/meetings-calendar-for-press"
    },
    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }

      this.menuClick = false;
    },
    onMenuToggle() {
      this.menuClick = true;

      if (this.isDesktop()) {
        if (this.layoutMode === 'overlay') {
          if (this.mobileMenuActive === true) {
            this.overlayMenuActive = true;
          }

          this.overlayMenuActive = !this.overlayMenuActive;
          this.mobileMenuActive = false;
        } else if (this.layoutMode === 'static') {
          this.staticMenuInactive = !this.staticMenuInactive;
        }
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }

      event.preventDefault();
    },
    onSidebarClick() {
      this.menuClick = true;
    },
    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
    },
    onLayoutChange(layoutMode) {
      this.layoutMode = layoutMode;
    },
    addClass(element, className) {
      if (element.classList)
        element.classList.add(className);
      else
        element.className += ' ' + className;
    },
    removeClass(element, className) {
      if (element.classList)
        element.classList.remove(className);
      else
        element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    },
    isDesktop() {
      return window.innerWidth >= 992;
    },
    isSidebarVisible() {
      if (this.isDesktop()) {
        if (this.layoutMode === 'static')
          return !this.staticMenuInactive;
        else if (this.layoutMode === 'overlay')
          return this.overlayMenuActive;
      }
      return true;
    },
    init() {
      this.applicationStore.initCountries();
      this.applicationStore.initOrganisationTypes();
    }
  },
  beforeMount() {
    this.init()
  }
}
</script>

<style lang="scss">
@import './App.scss';

.layout-body-top {
  background-image: url("/public/images/bg_header_default.png") !important;
}

</style>
